// extracted by mini-css-extract-plugin
module.exports = {"root":"UserNav_root__MukAU","tab":"UserNav_tab__3t1t9"};